var exports = {
  "kL": "ThreadWelcomeSection.module__container___S0VWc3",
  "Kk": "ThreadWelcomeSection.module__icon___S0VWc3",
  "e5": "ThreadWelcomeSection.module__iconGlyph___S0VWc3",
  "R_": "ThreadWelcomeSection.module__heading___S0VWc3",
  "h_": "ThreadWelcomeSection.module__description___S0VWc3",
};

module.exports = exports;
